<template>
    <button class="btn btn-outline-light" v-on:click="reverse"> {{ realName }} </button>
</template>

<script>

    export default {
        data() {
            return {

            }
        },
        props: {sort: null},

        computed: {
            realName : function() {
                if (this.sort == 'name' || this.sort == 'tag'){
                    return 'A→Z';
                }
                if (this.sort == 'last' || this.sort == 'stationary' || this.sort == 'sub_end_date'){
                    return 'Récent→Ancien';
                }
                if (this.sort == 'battery'){
                    return 'Min → Max';
                }
                if(this.sort == 'revertname' || this.sort == 'reverttag'){
                    return 'Z→A';
                }
                if (this.sort == 'revertlast' || this.sort == 'revertstationary' || this.sort == 'revertsub_end_date'){
                    return 'Ancien→Récent';
                }
                if (this.sort == 'revertbattery'){
                    return 'Max → Min';
                }
                // let splitRealName = this.realName.split('→');
                // let newRealName = splitRealName[1] +'→'+ splitRealName[0];
              return 'A→Z';
            }
        },
        methods: {
            reverse: function() {

                // this.$emit('revertSort', (this.sort.match(/revert/) ? this.sort.replace('revert','') : 'revert' + this.sort));

                if(this.sort.match(/revert/)) {
                    this.$emit('revertSort', this.sort.replace('revert',''));
                    // console.log('revert')
                    
                }
                else {
                    this.$emit('revertSort', 'revert' + this.sort);
                    // console.log('revert inversé')
                }
            }
        }

    }

</script>

<style scoped>

button {
    position: absolute;
    font-size: .6rem;
    right: 10px;
}

button:focus{
    outline: none;
    box-shadow: none;
}

/* @media screen and (max-width: 1600px) {
  button {
      position: relative;
  }
} */
</style>
